const titles = {
  '/': '中银跨境GO  超级大返现',
  '/list?type=master': '长城跨境通国际借记卡',
  '/list?type=visa': '长城跨境通国际借记卡',
  '/detail?type=master': '万事达卡借记卡客户营销活动',
  '/detail?type=visa': 'Visa海淘七重大礼享不停',
  '/card?type=master&card=0': '万事达卡世界借记卡',
  '/card?type=master&card=1': '万事达卡金卡借记卡',
  '/card?type=master&card=2': '万事达卡白金借记卡',
  '/card?type=master&card=3': '万事达卡非人哉借记卡',
  '/card?type=master&card=0&fromList=true': '万事达卡世界借记卡',
  '/card?type=master&card=1&fromList=true': '万事达卡金卡借记卡',
  '/card?type=master&card=2&fromList=true': '万事达卡白金借记卡',
  '/card?type=master&card=3&fromList=true': '万事达卡非人哉借记卡',
  '/card?type=visa&card=0': 'Visa白金借记卡',
  '/card?type=visa&card=1': 'Visa金卡借记卡',
  '/card?type=visa&card=2': 'Visa冬奥借记卡（黑卡）',
  '/card?type=visa&card=3': 'Visa冬奥借记卡（蓝卡）',
  '/card?type=visa&card=0&fromList=true': 'Visa白金借记卡',
  '/card?type=visa&card=1&fromList=true': 'Visa金卡借记卡',
  '/card?type=visa&card=2&fromList=true': 'Visa冬奥借记卡（黑卡）',
  '/card?type=visa&card=3&fromList=true': 'Visa冬奥借记卡（蓝卡）'
};

export default titles;
